import { createReducer, on } from "@ngrx/store";
import { CatalogoStore } from "./catalogo.ty";
import { searchPaises, foundPaises, searchEstados, foundEstados, searchMunicipios, 
    foundMunicipios, searchCodigosPostales, foundCodigosPostales } from "./catalogo.actions";
const initialState:CatalogoStore = {
    dispatcher: null,
    paises: {
        data: [],
        loading: false
    },
    estados: {
        data: [],
        loading: false
    },
    municipios: {
        data: [],
        loading: false
    },
    codigosPostales: {
        data: [],
        loading: false
    },
    colonias: {
        data: [],
        loading: false
    }
}

export const CatalogoReducer = createReducer(
  initialState,
  on(searchPaises, (state) => {
    return {
      ...state,
      paises: {
        ...state.paises,
        loading: true
      }
    }
  }),
  on(foundPaises, (state, action) => {
    return {
      ...state,
      paises: {
        ...state.paises,
        data: action.data,
        loading: false
      }
    }
  }),
  on(searchEstados, (state) => {
    return {
      ...state,
      estados: {
        ...state.estados,
        loading: true
      }
    }
  }),
  on(foundEstados, (state, action) => {
    return {
      ...state,
      estados: {
        ...state.estados,
        data: action.data,
        loading: false
      }
    }
  }),
  on(searchMunicipios, (state) => {
    return {
      ...state,
      municipios: {
        ...state.municipios,
        loading: true
      }
    }
  }),
  on(foundMunicipios, (state, action) => {
    return {
      ...state,
      municipios: {
        ...state.municipios,
        data: action.data,
        loading: false
      }
    }
  }),
  on(searchCodigosPostales, (state) => {
    return {
      ...state,
      codigosPostales: {
        ...state.codigosPostales,
        loading: true
      }
    }
  }),
  on(foundCodigosPostales, (state, action) => {
    return {
      ...state,
      codigosPostales: {
        ...state.codigosPostales,
        data: action.data,
        loading: false
      }
    }
  })
);